import Phaser from "phaser";

export const ParticleType = {
  Generic: 'Generic',
  Fireworks: 'Fireworks',
} as const;
export type ParticleTypeKeys = keyof typeof ParticleType;
export type ParticleTypeValues = typeof ParticleType[ParticleTypeKeys];
export default class ParticleFX extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);
  }


}
